import { NodeDTO } from '@store/services/nodes/types';

/**
 * Picks the node a create request just added out of the response it returns.
 *
 * The endpoint answers with the whole model rather than the created entity, so
 * the new node is the one carrying an id the client had not seen. Creating an
 * asset re-scopes that response to the new asset, which makes several ids
 * unseen at once; the typed name then disambiguates within that set rather than
 * an arbitrary first match.
 *
 * The caller must collect `knownNodeIds` before awaiting the request: erring
 * towards extra unseen ids is recoverable here, missing the created one is not.
 */
export const resolveCreatedNode = (
  responseNodes: NodeDTO[],
  knownNodeIds: Set<string>,
  name: string,
): NodeDTO | undefined => {
  const unseen = responseNodes.filter(({ id }) => !knownNodeIds.has(id));

  if (unseen.length === 1) return unseen[0];

  return unseen.find((node) => node.name === name);
};

export default resolveCreatedNode;
